import { render, staticRenderFns } from "./FalhaImportacaoProdutosDialog.vue?vue&type=template&id=8a397a9c"
import script from "./FalhaImportacaoProdutosDialog.vue?vue&type=script&lang=js"
export * from "./FalhaImportacaoProdutosDialog.vue?vue&type=script&lang=js"
import style0 from "./FalhaImportacaoProdutosDialog.vue?vue&type=style&index=0&id=8a397a9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports